import { ExitIcon } from '@components/ExitIcon/ExitIcon';
import { useLibraryManager } from '@stores/LibraryManager/LibraryManager';
import { trackingStore } from '@stores/Tracking';
import { useUIPreferences } from '@stores/UIPreferences';
import { observer } from 'mobx-react';
import css from './ImageSearch.module.scss';

export const ImageSearch = observer(() => {
  const libraryManager = useLibraryManager();
  const librarySearch = libraryManager.multiLibSearch;
  const uiPreferences = useUIPreferences();

  if (!librarySearch.request?.image) return null;

  return (
    <div className={css.image}>
      <img src={librarySearch.request.image} alt="query image" />
      <ExitIcon
        onClick={() => {
          trackingStore.searchImageRemoved();
          librarySearch.setSearchImage(null);
          uiPreferences.searchBarFocusCallback?.();
        }}
      />
    </div>
  );
});
